import { Popover, Box, Tag } from '@nimbus-ds/components';
import { ChevronDownIcon, ChevronUpIcon } from '@nimbus-ds/icons';
import { useBoolean } from 'commons/hooks';

interface StatesPopoverProps {
  states: string[];
  statesName: (state: string) => string;
}
function StatesPopover({ states, statesName }: Readonly<StatesPopoverProps>) {
  const [popover, showPopover, hidePopover] = useBoolean(false);
  return (
    <Popover
      content={
        <Box gap="1" display="flex" flexDirection="row" flexWrap="wrap">
          {states.map((state) => (
            <Tag key={state}>{statesName(state)}</Tag>
          ))}
        </Box>
      }
      position="bottom"
      arrow={false}
      visible={popover}
      onVisibility={(current) => (current ? showPopover() : hidePopover())}
      maxWidth="300px"
    >
      {popover ? <ChevronUpIcon /> : <ChevronDownIcon />}
    </Popover>
  );
}

export default StatesPopover;
